import { Result } from '@wanjianshi/admin-ui';
import type { ReactNode } from 'react';
import { useAdminAuth } from '@/auth/store';

export function PermissionRoute({ permission, children }: { permission: string; children: ReactNode }) {
  const allowed = useAdminAuth(state => state.hasPermission(permission));
  return allowed ? children : <Result status="403" title="403" subTitle="无权访问该功能" />;
}
